import { render, staticRenderFns } from "./BillingList.vue?vue&type=template&id=22defafa&"
import script from "./BillingList.vue?vue&type=script&lang=js&"
export * from "./BillingList.vue?vue&type=script&lang=js&"
import style0 from "./BillingList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "BillingList.vue"
export default component.exports